import React from 'react';
import moment from 'moment';
import { DatePicker, Cascader } from 'antd';

function disabledDate(current) {
  return current && current.valueOf() > moment().add(-1, 'days');
}
const dateFormat = 'YYYY/MM/DD';
class DatePickerComponent extends React.Component {
  render() {
    return (
      <div>
        <DatePicker
          showToday={false}
          allowClear={false}
          onChange={this.props.onChange}
          defaultValue={moment().add(-1, 'day')}
          format={dateFormat}
          disabledDate={disabledDate}
        />
      </div>
    );
  }
}
export default DatePickerComponent;



// WEBPACK FOOTER //
// ./src/components/DatePicker.js